import React from "react";

import { createHashRouter } from "react-router-dom";

import { Grid, Typography } from "@mui/material";
import App from "./App";
import { ERoute } from "./constants";
import {
  ChannelPage,
  HomePage,
  MyPlacePage,
  SavedVideoPage,
  VideoPage,
} from "./pages";

const router = createHashRouter([
  {
    path: "/",
    element: <App />,
    loader: () => <div>ROOT LOADER</div>,
    children: [
      {
        path: ERoute.HOME,
        element: <HomePage />,
        loader: () => <Typography>Loading...</Typography>,
      },
      {
        path: ERoute.SAVED_VIDEO,
        element: <SavedVideoPage />,
        loader: () => <Typography>Loading...</Typography>,
      },
      {
        path: ERoute.MY_PLACE,
        element: <MyPlacePage />,
        loader: () => <Typography>Loading...</Typography>,
      },
      {
        path: ERoute.CHANNEL,
        element: <ChannelPage />,
        loader: () => <Typography>Loading...</Typography>,
        children: [
          {
            path: ":channelId",
            element: <ChannelPage />,
            loader: () => <Typography>Loading...</Typography>,
          },
        ],
      },
      {
        path: ERoute.VIDEO,
        element: <VideoPage />,
        loader: () => <Typography>Loading...</Typography>,
      },
      {
        path: "*",
        element: <Grid>Not found Page</Grid>,
      },
    ],
  },
]);

export default router;
